import { Modal } from '@mui/material';
import CustomButton from '../Button/CustomButton';
import IconButton from '@mui/material/IconButton';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import MaterialTooltip from '../tooltip/MaterialTooltip';

const SimpleModal = ({
  isModalOpen,
  setIsModalOpen,
  handleConfirm,
  title = 'Modal sin título',
  description = 'Sin descripción',
  tooltip,
  titleTooltip,
}) => {
  return (
    <Modal
      open={isModalOpen}
      onClose={(e) => {
        e.stopPropagation();
        setIsModalOpen(false);
      }}
      className="modal-pdf-wrapper"
    >
      <div onClick={(e) => e.stopPropagation()} className="modal-pdf-container">
        <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
          <h1 style={{ padding: '0' }}>{title}</h1>
          {tooltip && (
            <MaterialTooltip variation="warning" title={titleTooltip} placement="right-start">
              <IconButton className="alert-message">
                <ReportProblemIcon color="warning" />
              </IconButton>
            </MaterialTooltip>
          )}
        </div>
        <p>{description}</p>

        <div className="modal-pdf-buttons-container">
          <CustomButton onClick={() => setIsModalOpen(false)} variant="secondary">
            No
          </CustomButton>
          <CustomButton disabled={tooltip} onClick={(e) => handleConfirm(e)}>
            Sí
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default SimpleModal;
